export default "__VITE_ASSET__102c1d4e__"